import React, { Component } from 'react';
import Mask from '../components/mask'
import Bubble from '../components/bubble'
import InputNumber from '../../../components/InputNumber'
import {Button, List, InputItem, Flex, Radio, Picker, WingBlank, WhiteSpace,Toast} from 'antd-mobile';
import '../create.css'
import axios from 'axios'
import {ROOT_PATH} from '../../../config';
import auth from '../../../utils/auth';
import sendinit from '../../../utils/send_init';
import send from '../../../utils/send';
export default class Farm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      latitude: '',//编辑
      longitude: '',//编辑
      method: 'ADD',//新增ADD,更新UPDATE,删除DELETE
      data: [],//地址
      mask: false,
      farmName: '',
      farmType: 'SW', // SW 种猪场， 肥猪是PG
      farmScale: '',
      farmMan: '',
      tel: '',
      address: [],
      asyncValue: [],
      addressSource: [],
      tooltips: [
        {
          message: '您的猪场信息如果填写完成，可以点击【完成】按钮，进入下一步。',
          position: {
            top: 130
          },
          visible: true
        }
      ]
    }
  }
  doSaveCheck = () => {
    let err = 0;
    const {farmName, farmScale, tel, farmMan,address} = this.state;
    if (!farmName){
      Toast.info('请输入 农场名称');
      err++;
    } else if (farmScale * 1 === 0) {
      Toast.info('请输入 猪场规模');
      err++;
    } else if (farmMan * 1 === 0) {
      Toast.info('请输入 猪场负责人');
      err++;
    } else if (!(/^1[3456789]\d{9}$/.test(tel))) {
      Toast.info('请输入 手机号码');
      err++;
    } else if (address.length === 0) {
      Toast.info('请选择 猪场地址');
      err++;
    }
    return err === 0
  };
  doSave = () => {
    auth.getPosition();
    // 1. 校验数据
    //2. 请求农场代码
    const check = this.doSaveCheck();
    if (!check) return;
    // 是否是更新。
    const {pathname} = this.props.location;
    if (pathname === '/createfarm/farm_edit') {
      this.saveEditData()
    } else if (pathname === '/createfarm/farm_add') {
      this.saveData()
    }

  };
  saveEditData = () => {
    const {farmScale, farmName, farmMan, tel, farmType, address,method} = this.state;
    const province = JSON.parse(address[0] || '');
    const city = JSON.parse(address[1] || '');
    const town = JSON.parse(address[2] || '');
    send({
      url: `/api/forward/ifarm/simpleFarm/save`,
      method: 'post',
      data: {
        cityCode: city.code,
        cityName: city.name, // 城市
        farmCapacity: farmScale, // 猪场规模
        farmLocaion:`${ province.name},${city.name},${town.name}`, // 猪场地址描述
        farmLocaionCode: town.code, //猪场地址代码
        farmManager: farmMan,
        farmManagerContact: tel,
        farmName: farmName,
        farmType,
        latitude: window.lat,
        longitude: window.lng,
        method,
        provinceCode: province.code,
        provinceName: province.name
      }
    }).then(res => {
      if (res.data.error) {
        Toast.info(res.data.msg, 3)
      } else {
        Toast.info('更新成功',1,() =>{
          this.props.history.replace('/farm_list')
        })
      }
    })
  };
  saveData = () => {
    const {farmScale, farmName, farmMan, tel, farmType, address,method} = this.state;
    const province = JSON.parse(address[0] || '');
    const city = JSON.parse(address[1] || '');
    const town = JSON.parse(address[2] || '');
    sendinit({
      url: `${ROOT_PATH}/api/forward/ifarm/simpleOrg/save`,
      method: 'post',
      data: {
        cityCode: city.code,
        cityName: city.name, // 城市
        farmCapacity: farmScale, // 猪场规模
        farmLocaion: `${ province.name},${city.name},${town.name}`, // 猪场地址描述
        farmLocaionCode: town.code, //猪场地址代码
        farmManager: farmMan,
        farmManagerContact: tel,
        farmName: farmName,
        farmType,
        latitude: window.lat,
        longitude: window.lng,
        method,
        provinceCode: province.code,
        provinceName: province.name
      }
    }).then(res => {
      if (res.data.error) {
        Toast.info(res.data.msg)
      }else {
        this.setData();
        auth.setCookie('FARMORG', res.data.farmOrg);
        auth.setCookie('ORGCODE', res.data.orgCode);
        auth.setCookie('path', '/createfarm/loc_add');
        this.props.history.replace('/createfarm/loc_add')
      }
    })
  };
  async componentDidMount () {
    Toast.loading('请稍等',5);
    // 地址
    let res = await axios.get(
      `${ROOT_PATH}/api/ifarm/v180/address/list?parent_code=0`,
    );
    let resData = res.data.data;
    for (var i = 0; i < resData.length; i++) {
      var data = resData[i];
      data.label = data.name;
      data.value = JSON.stringify({name: data.name, code: data.code, lat: data.lat, lng: data.lng});
      for (var j = 0; j < data.children.length; j++) {
        var c1 = data.children[j];
        c1.label = c1.name;
        c1.value = JSON.stringify({name: c1.name, code: c1.code, lat: c1.lat, lng: c1.lng});
        for (var k = 0; k < c1.children.length; k++) {
          var c2 = c1.children[k];
          c2.label = c2.name;
          c2.value = JSON.stringify({name: c2.name, code: c2.code, lat: c2.lat, lng: c2.lng});
        }
      }
    }
    Toast.hide();
    this.setState({
      data: resData
    });
    // 判断是add - edit
    const {pathname} = this.props.location;
    let farmData = {};
    // 当是新增界面，则读取是否本地存储
    if (pathname === '/createfarm/farm_add') {
      // 此时是新增界面。读取本地值，
      farmData = auth.readCookie('farm');
      // 此时是否已经创建过农场.
      this.setState({
        ...farmData,
        method:'ADD',
        mask: auth.readCookie('ISFIRST')
      });
    } else if (pathname === '/createfarm/farm_edit') {
      // 此时是编辑。
      const propsState = this.props.location.state;
      this.setState({
        farmName: propsState.nameLoc,
        farmType: propsState.project,
        farmMan: propsState.managerName,
        farmScale: propsState.project === 'SW'?propsState.capacity:propsState.capacityPiglet,
        tel: propsState.phoneNo,
        address: [],
        latitude: propsState.lat,
        longitude: propsState.lng,
        method: 'UPDATE'
      });
      if (propsState.gpsLocation) {
        let addressData = propsState.gpsLocation.split(',');
        let address = [];
        if (addressData.length === 3) {
          //  符合地址要求，取值去。
          const province = resData.find(o => o.label === addressData[0]);
          const city = province.children.find(o =>o.label === addressData[1]);
          const town = city.children.find(o =>o.label === addressData[2]);
          const p = JSON.stringify({name: province.name, code: province.code, lat: province.lat, lng: province.lng});
          const c = JSON.stringify({name: city.name, code: city.code, lat: city.lat, lng: city.lng});
          const t = JSON.stringify({name: town.name, code: town.code, lat: town.lat, lng: town.lng});
          address.push(p,c,t);
          this.setState({
            address
          })
        }
      }
    }
  }
  componentWillUnmount() {
    this.setState = () => false
  }

  setData = () => {
    const {farmMan,
      farmName,
      farmScale,
      farmType,
      tel,
      address} = this.state;
   /* //为什么要给默认值啊
   const ini = JSON.stringify({code: '',name: '',lat:'',lng: ''});
    if (address.length === 0) {
      address.push(ini,ini,ini)
    }*/
    auth.setCookie('farm', {
      farmMan,
      farmName,
      farmScale,
      farmType,
      tel,
      address
    })
  };
  render() {
    const {
      farmName,
      tel,
      address,
      farmType,
      farmScale,
      farmMan,
      hasError,
      mask
    } = this.state;
  return (
    <React.Fragment >
      <div >
        <List renderFooter={() => ''}
            renderHeader={() => ''}
        >
          <InputItem className={'required text-right'}
              placeholder={'请输入'}
              maxLength={15}
              type={'text'}
              value={farmName}
              onChange={v => {
                       this.setState({
                         farmName: v
                       }, () => {
                         this.setData()
                       })
                     }}
          >
            猪场名称
          </InputItem>
          <List.Item className={'required span-4'}
              extra={
                       <Flex justify={'end'}>
                         <Radio className="my-radio"
                             style={{marginRight: 15}}
                             checked={farmType === 'SW'}
                             onChange={() => {
                                  this.setState({
                                    farmType: 'SW'
                                  }, () => {
                                    this.setData()
                                  })
                                }}
                         >种猪场</Radio>
                         <Radio className="my-radio"
                             checked={farmType === 'PG'}
                             onChange={() => {
                                  this.setState({
                                    farmType: 'PG'
                                  }, () => {
                                    this.setData()
                                  })
                                }}
                         >肥猪场</Radio>
                       </Flex>
                     }
          >
            猪场类型
          </List.Item>
          <InputNumber className={'required text-right'}
              value={farmScale}
              placeholder={'请输入'}
              precision={0}
              onChange={(v) => {
                         let farmScale = v.substr(0,9);
                         this.setState({farmScale}, () => {
                           this.setData()
                         })
                       }}
          >
            猪场规模
          </InputNumber>
          <InputItem className={'required text-right'}
                     disabled={this.state.method === 'UPDATE'}
              placeholder={'请输入'}
              maxLength={5}
              type={'text'}
              value={farmMan}
              onChange={v => {
                       this.setState({
                         farmMan: v
                       }, () => {
                         this.setData()
                       })
                     }}
          >
            猪场负责人
          </InputItem>
          <InputNumber
              clear
              className={'required text-right'}
              disabled={this.state.method === 'UPDATE'}
              placeholder="请输入"
              error={hasError}
              pattern={'[0-9]*'}
              onErrorClick={()=> {
                Toast.info(this.state.errMsg)
              }}
              onChange={value => {
                value=value.substr(0,11);
                value = value.replace(/ /g,'');
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                this.setState({
                  hasError: true,
                  errMsg: '请输入正确的手机号'
                });
              } else {
                this.setState({
                  hasError: false
                });
              }
              this.setState({
                tel: value
              }, () => {
                this.setData()
              });
            }}
              value={tel}
          >手机号码</InputNumber>

          <Picker extra="请选择"
              data={this.state.data}
              disabled={this.state.method === 'UPDATE'}
              title="地址"
              value={address}
              onOk={(e) => {
                console.log(e);
                this.setState({address: e}, () => {
                  this.setData()
                })
              }}
          >
            <List.Item  arrow={'horizontal'}
                        className={(address.length=== 0) ? 'am-list-extra-empty span-4 required':'span-4 required'}>
              猪场地址
            </List.Item>
          </Picker>

        </List>

        <WingBlank size="lg">
          <WhiteSpace size={'lg'} />
          <Button type={'primary'}
              className={this.state.mask? 'topShow w-10': ''}
              onClick={() => {
                    if (!mask) {
                      this.doSave()
                      // this.test)
                    }
                  }}
          >完成</Button>
        </WingBlank>

        <Mask visible={this.state.mask}
            onClick={() => {
          this.setState({
            mask: false
          })
        }}
        >
          {
            this.state.tooltips.map((item, index) => {
              return <Bubble {...item.position}
                  key={index}
                  visible={'true'}
                  showtips={'true'}
                     >
                <div style={{height: 230}}>
                  {item.message}
                  <div className={'line'} />
                </div>
              </Bubble>
            })
          }
        </Mask>
      </div>
    </React.Fragment>
  )
 }
}
